<div class="keyboard-filler" (window:resize)="onResize()" [ngStyle]="{height:keyboardHeightCalculated+'px'}">
</div>
